import {ColumnProps} from 'antd/lib/table';
import {Webhook, useWebhooksQuery} from 'api/generated';
import {Stack, TableCard} from 'components';
import {useTableSearch} from 'hooks/useTableSearch';
import React, {useState} from 'react';
import {formatBoolean} from 'lib/formaters';
import {Tag, Typography, Table, Tooltip} from 'antd';
import {CreateWebhook} from './CreateWebhook';
import {WebhookActions} from './WebhookActions';
import {EventType} from 'types';

const {Text} = Typography;

export const WebhooksSettings: React.FC<any> = ({cardProps, accountId, masterAccount}) => {
  const {data, loading} = useWebhooksQuery({variables: {accountId: accountId}});
  const [size, setSize] = useState(10);
  const [from, setFrom] = useState(0);

  const webhooks = data?.webhooks.items;
  const total = data?.webhooks.items.length || 0;

  const columns: Array<ColumnProps<Webhook>> = [
    useTableSearch({
      title: 'URL',
      dataIndex: 'url',
      className: 'minimized-cell',
      render(_, webhook) {
        return <Text copyable>{webhook.url}</Text>;
      }
    }),
    {
      title: 'Event types',
      dataIndex: 'eventTypes',
      className: 'minimized-cell',
      render: (eventTypes) => (
        <Stack gutter={1}>
          {eventTypes.slice(0, 3).map((event: string) => (
            <Tag key={event}>{EventType[event as keyof typeof EventType]}</Tag>
          ))}
          {eventTypes.length > 3 && (
            <Tooltip
              title={eventTypes
                .map((event: string) => EventType[event as keyof typeof EventType])
                .join(', ')}>
              <Tag>...</Tag>
            </Tooltip>
          )}
        </Stack>
      )
    },
    {
      title: 'Enabled',
      dataIndex: 'enabled',
      className: 'minimized-cell',
      render: (enabled) => formatBoolean(enabled)
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'right',
      className: 'minimized-cell',
      render: (_, webhook) => (
        <WebhookActions webhook={webhook} accountId={accountId} masterAccount={masterAccount} />
      )
    }
  ];

  return (
    <TableCard
      title="Webhooks"
      extra={<CreateWebhook accountId={accountId} masterAccount={masterAccount} />}
      {...cardProps}>
      <Table
        rowKey="url"
        scroll={{x: true}}
        dataSource={webhooks as Webhook[]}
        columns={columns as any}
        loading={loading}
        pagination={{
          total,
          pageSize: size,
          hideOnSinglePage: true,
          current: from / size + 1,
          onShowSizeChange: (current, pageSize) => {
            setSize(pageSize);
            setFrom((current - 1) * pageSize);
          },
          onChange: (page, size = 0) => setFrom((page - 1) * size)
        }}
      />
    </TableCard>
  );
};
